$(window).ready(function () {
    newsHover();
    cookies();
    language();
    slides();
    scrollToSection();
    formHandler();
    menuOpen();
    fileUpload();
});

$(window).on("load", function () {
    fold();
    hash();
});

function hash() {
    var target = $('[data-hash="'+location.href.split("#")[1]+'"]');
    var hash = location.href.split("#")[1];

    var header = $('header').outerHeight();
    if (target.length) {
        location.hash = hash;
        $('html,body').animate({ scrollTop: target.offset().top - header }, 0);
    }

}


$(window).on('scroll', function () {
});

$(window).on('resize', function () {

});

AOS.init({
    once: true,
    duration: 600,
    easing: 'ease-in-out-sine',
});

function menuOpen() {
    var button = $('.menu-toggle');

    button.click(function(){
        $('.menu-toggle').toggleClass('active');
        $('.menu-wrap').toggleClass('active');
    })

    $('.menu-wrap a').click(function () {
        $('.menu-toggle').removeClass('active');
        $('.menu-wrap').removeClass('active');
    })

    $('header').click(function(e){
        e.stopPropagation();
    })
    $('body').click(function(){
        $('.menu-toggle').removeClass('active');
        $('.menu-wrap').removeClass('active');
    })


}

function cookies() {
    if ($('.cookies').length > 0) {
        setTimeout(function () {
            $('.cookies').addClass('active');
        }, 5000);

        $('.cookies .cookies-agree').on('click', function () {
            var d = new Date();
            d.setTime(d.getTime() + (360 * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = "cookie-policy=agree;" + expires + ";path=/";
            $('.cookies').removeClass('active');
        });
        $('.cookies .cookies-decline').on('click', function () {
            $('.cookies').removeClass('active');
        });
    }
}

function language() {
    var currentLang = $('.current-language');

    currentLang.click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.languages-list').removeClass('active');
        } else {
            $(this).addClass('active');
            $('.languages-list').addClass('active');
        }
    })
}

var whichTransitionEvent = function () {
    var t;
    var el = document.createElement('fakeelement');
    var transitions = {
        'transition': 'transitionend',
        'OTransition': 'oTransitionEnd',
        'MozTransition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd'
    };

    for (t in transitions) {
        if (el.style[t] !== undefined) {
            return transitions[t];
        }
    }
};

//RANDOM VARS
var isMS = navigator.userAgent.indexOf('MSIE') != -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || navigator.userAgent.indexOf('Edge') != -1,
    isIE = navigator.userAgent.indexOf('MSIE') != -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./),
    isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
    isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1,
    transitionEvent = whichTransitionEvent(),
    a = 0,
    lastY = 0;

function fold() {
    $('.fold-image .overlay').addClass('active');
    $('.fold-image .background-image').addClass('active');
    $('.title-wrap, .title-wrap-bottom').addClass('active');
    $('.fold, .fold-bottom').addClass('active');
    $('header').addClass('active');
    // setTimeout(function(){
    //     afterLoad();
    // },1200);
    // function afterLoad() {
    //     $('.fold .text-overflow').each(function(){
    //         var items = $(this).children('span');
    //         for(var i = 0; i < items.length ;i++) {
    //             animation(i);
    //         }
    //         function animation(i) {
    //             var item = items[i];
    //             setTimeout(function(){
    //                 $(items[i]).removeClass('hide');
    //             },70 * i)
    //         }
    //     })
    // }
}

function newsHover() {
    var item = $('.news-wrapper .new');

    item.mouseout(function () {
        $(this).parent().siblings().children('.new').removeClass('grayscale');
        $(this).removeClass('grayscale');
    })
    item.mouseover(function () {
        $(this).parent().siblings().children('.new').addClass('grayscale');
        $(this).removeClass('grayscale');
    })
}

function scrollToSection() {
    var button = $('.js-scroll');
    button.click(function (e) {
        e.preventDefault();
        var hash = $(this).prop("hash");
        var section = $(hash);
        var header = $('header').outerHeight();
        $('html,body').animate({
            scrollTop: section.offset().top - header
        }, 500);
    })
}

function slides() {

    if ($('.swiper-process').length > 0) {
        // var offset = Math.round($('.our-process .wrapper').eq(0).offset().left) + 20;
        // $(window).on('resize', function () {
        //     offset = Math.round($('.our-process .wrapper').eq(0).offset().left) + 20;
        //     if (swiperGallery !== 'undefined' && !window.matchMedia("(max-width: 1050px)").matches) {
        //         swiperGallery.params.slidesOffsetBefore = offset;
        //         swiperGallery.params.slidesOffsetAfter = offset;
        //         swiperGallery.update();
        //     }
        // });
        var swiperGallery = new Swiper('.swiper-process', {
            direction: 'horizontal',
            loop: false,
            freeMode: false,
            autoplay: false,
            spaceBetween: 88,
            slidesPerView: 'auto',
            // slidesOffsetBefore: offset,
            // slidesOffsetAfter: offset,
            centeredSlides: true,
            navigation: {
                nextEl: '.swiper-bottom .swiper-next',
                prevEl: '.swiper-bottom .swiper-prev',
            },
            pagination: {
                el: '.swiper-bottom .swiper-pagination-custom',
                clickable: true,
                renderBullet: function (index, className) {
                    var totalSlides = $('.swiper-process .swiper-slide').length;
                    // var value = (index + 1)/totalSlides;
                    var value = 1

                    return '<div class="' + className + '"><div class="swiper-progress"  data-value="' + value + '"></div> <div class="text">' + (index + 1) + '</div></div>';
                }
            },
            observerUpdate: true,
            // breakpoints: {
            //     767: {
            //         slidesPerView: 1,
            //         spaceBetween: 20,
            //         slidesOffsetBefore: 0,
            //         slidesOffsetAfter: 0,
            //         lazy: {
            //             loadPrevNextAmount: 2,
            //             loadPrevNext: true,
            //             loadOnTransitionStart: true,
            //         },
            //     },
            //     1050: {
            //         slidesPerView: 2,
            //         spaceBetween: 20,
            //         slidesOffsetBefore: 0,
            //         slidesOffsetAfter: 0,
            //     }s
            // }
        })

        swiperGallery.on('slideChange', function () {
            $('.swiper-progress').circleProgress({
                size: 65,
                fill: "#0057A2",
                emptyFill: 'rgba(0, 87, 162, .1)',
                thickness: 2,
                // animation: false
            });
        });

        $('.swiper-progress').circleProgress({
            size: 65,
            fill: "#0057A2",
            emptyFill: 'rgba(0, 87, 162, .1)',
            thickness: 2,
            // animation: false
        });
    }
}

function formHandler() {
    $('.wpcf7').on('change keyup keydown paste cut', 'textarea', function () {
        $(this).height(0).height(this.scrollHeight);
    }).find('textarea').change();
}

// Contact forms
//INPUTS HANDLERS

//INPUTS HANDLERS

var submitButton = $('.wpcf7-form').find('.button')

var onSentBad = function () {
        var eventID = event.detail.contactFormId;
        var submitButton = $('[id^=wpcf7-f' + eventID + ']').find('.button');
        submitButton.removeClass('loading');
        var inputs = $('[id^=wpcf7-f' + eventID + ']').find('input, textarea');
        var errors = $('[id^=wpcf7-f' + eventID + ']').find('.wpcf7-not-valid-tip');
        inputs.each(function () {
            if ($(this).hasClass('wpcf7-not-valid')) {
                $(this).closest('.input-wrap').addClass('error');
            }
        })

        setTimeout(function () {
            errors.addClass('active');
            $('[id^=wpcf7-f' + eventID + ']').find('.error-text').addClass('active');
        }, 50)

    },
    onSentOk = function (event) {
        var eventID = event.detail.contactFormId;
        var submitButton = $('[id^=wpcf7-f' + eventID + ']').find('.button');
        submitButton.removeClass('loading');

        var success = $('[id^=wpcf7-f' + eventID + ']').find('.success');

        success.addClass('active');

        setTimeout(function () {
            success.removeClass('active');
        }, 5000)

        var full = $('[id^=wpcf7-f' + eventID + ']').find('.full');
        full.removeClass('full');

    },
    onSubmit = function () {
    };

$('.wpcf7').on('focus change', '.wpcf7-not-valid', function () {
    $(this).removeClass('wpcf7-not-valid');
    $(this).closest('.input-wrap').removeClass('error');
    $(this).siblings('.wpcf7-not-valid-tip').removeClass('active');
    $('.error-text').removeClass('active');
})

submitButton.click(function(){
    $(this).addClass('loading');
})


$(document).on('wpcf7submit', onSubmit);
$(document).on('wpcf7mailsent', onSentOk);
$(document).on('wpcf7invalid ', onSentBad);

$("textarea, input").on("change keyup keydown keypress paste textInput input", function () {
    if ($(this).val().length > 0) {
        console.log('test');
        $(this).closest(".input-wrap").addClass("full");
    } else {
        $(this).closest(".input-wrap").removeClass("full");
    }
})

//HANDLE URLS PARAMS

jQuery.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null){
        return null;
    }
    else{
        return decodeURI(results[1]) || 0;
    }
};

jQuery(document).ready(function (e) {
    var permission = jQuery.urlParam('sutikimas');
    var key = jQuery.urlParam('key');
    var modal = jQuery('.modal');
    var buttons = jQuery('.privacy-policy .buttons');

    if(!key) {
        buttons.addClass('hide');
    }

    var showModal = function () {
        modal.addClass('show').one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
            modal.find('.modal-inner').addClass('show');
        })
    };

    if(permission){
        if(permission === 'true'){

            modal.removeClass('disagree').addClass('agree');

            showModal();

        }else if(permission === 'false') {

            modal.removeClass('agree').addClass('disagree');

            showModal();

        }

        buttons.addClass('hide');
    }

    modal.on('click', function (e) {
        console.log(e);
        if(!(jQuery(e.target).closest('.modal-inner').length > 0) || jQuery(e.target).hasClass('close')) {
            modal.find('.modal-inner').removeClass('show').one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
                modal.removeClass('show');
            })
        }
    });


    jQuery('.privacy-policy .buttons .btn').on('click', function (e) {

        var btn = jQuery(this);

        if(typeof key !== 'undefined'){

            jQuery.ajax({
                type:"POST",
                url: icl_vars['ajax_url'],
                data: {
                    action: "inform_permission",
                    key : key,
                    permission : btn.data('agree')
                },
                success:function(data){
                    if(data.data){

                        modal.addClass('agree');

                        showModal();

                    }else {

                        modal.addClass('disagree');

                        showModal();

                    }

                    buttons.addClass('hide');
                }
            });
        }
    })
});

jQuery('.privacy-policy .user-agreement form').on('submit', function (event) {
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);

    var inputs = jQuery(this).find('input');

    inputs.removeClass('error');

    var modal = jQuery('.modal');

    modal.addClass('show');

    var pass = true,
        ids = [];

    var nameRegex = /^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/;

    var nameInput = jQuery('#user-name');

    if(!nameInput.val().match(nameRegex)) {
        pass = false;
        ids.push('#user-name');
    }

    var emailRegex =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    var emailInput = jQuery('#user-email');
    var langInput = jQuery('#user-lang');

    if(!emailInput.val().match(emailRegex)) {
        pass = false;
        ids.push('#user-email');
    }

    if(!pass) {

        modal.removeClass('agree').addClass('disagree');
        modal.find('.modal-inner').addClass('show');

        for(var a = 0; a<ids.length; a++) {
            jQuery(ids[a]).addClass('error');
        }

    }else {
        jQuery.ajax({
            type: "POST",
            url: postfriisberg['ajax_url'],
            data: {
                action: "ind_user_permission",
                email: emailInput.val(),
                name: nameInput.val(),
                lang: langInput.val(),
            },
            success: function(data){
                //console.log(data.data.success);

                if(data.data.success) {
                    modal.removeClass('disagree').addClass('agree');
                    modal.find('.modal-inner').addClass('show');

                    inputs.val('');

                }else {
                    modal.removeClass('agree').addClass('disagree');
                    modal.find('.modal-inner').addClass('show');

                    var ids = data.data.ids;

                    if(ids) {
                        for(var a = 0; a<ids.length; a++) {
                            jQuery(ids[a]).addClass('error');
                        }
                    }
                }
            }
        });
    }
});

function fileUpload() {
    $('input[type=file]').change(function () {
        var file = $(this).val().replace(/C:\\fakepath\\/i, '');

        if (file) {
            var fileFormat = file.substr(file.lastIndexOf('.'));
            var fileName = file.replace(fileFormat, '');
        } else {
            fileFormat = '';
            fileName = $(this).closest('.file-wrap').children('.file-name').data('text-original');
        }

        var nameField = $(this).closest('.file-wrap').children('.file-name').children('.filename');
        var formatField = $(this).closest('.file-wrap').children('.file-name').children('.file-format');
        nameField.html(fileName);
        formatField.html(fileFormat);
        $(this).closest('.input').removeClass('error');
    })
}
